import { render } from "./Loading.vue?vue&type=template&id=67e248ae&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=67e248ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e248ae"]])

export default __exports__